import {
  Grid,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  TextField,
} from "@mui/material";

const MatchingAnswer = ({
  questionData,
  handleRangeChange,
  handleMatchingAnswerChange,
  baseQuestion
}) => {
  const renderLabel = () => {
    if (
      questionData.questionType === "choice" &&
      questionData.matchingCriteria === "different"
    ) {
      return "Choose one answer";
    } else if (
      questionData.questionType === "multipleChoice" &&
      questionData.matchingCriteria === "multiple"
    ) {
      return "You can choose more than one matching answer";
    }
    return "";
  };

  if (questionData.questionType === "range") {
    return (
      <>
        <Grid item xs={12} sm={6}>
          <FormControl fullWidth>
            <TextField
              label="Lower Range Value"
              value={questionData.lowerRangeValue}
              onChange={(e) =>
                handleRangeChange("lowerRangeValue", e.target.value)
              }
              disabled={baseQuestion}
            />
            <Typography variant="caption">
              This must be a whole number
            </Typography>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Lower Range Label"
            value={questionData.lowerRangeLabel}
            onChange={(e) =>
              handleRangeChange("lowerRangeLabel", e.target.value)
            }
            disabled={baseQuestion}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormControl fullWidth>
          <TextField
              label="Upper Range Value"
              value={questionData.upperRangeValue}
              onChange={(e) =>
                handleRangeChange("upperRangeValue", e.target.value)
              }
              disabled={baseQuestion}
            />
            <Typography variant="caption">
              This must be a whole number
            </Typography>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Upper Range Label"
            value={questionData.upperRangeLabel}
            onChange={(e) =>
              handleRangeChange("upperRangeLabel", e.target.value)
            }
            disabled={baseQuestion}
          />
        </Grid>
      </>
    );
  }

  // if (
  //   questionData.matchingCriteria === "different" ||
  //   questionData.matchingCriteria === "multiple"
  // ) {
  //   return (
  //     <Grid item xs={6}>
  //       {questionData.questionType === "yesno" && (
  //         <>
  //           <TextField
  //             label="Matching Answer"
  //             disabled
  //             value="Opposite of user's choice"
  //             fullWidth
  //           />
  //           <Typography variant="caption" color="textSecondary">
  //             Matching answer will be opposite of whatever user chooses.
  //           </Typography>
  //         </>
  //       )}
  //       {(questionData.questionType === "choice" ||
  //         questionData.questionType === "multipleChoice") && (
  //         <FormControl fullWidth>
  //           <InputLabel>Matching Answer</InputLabel>
  //           <Select
  //             multiple={questionData.questionType === "multipleChoice"}
  //             value={
  //               questionData.matchingAnswer
  //                 ? questionData.matchingAnswer.split(",")
  //                 : []
  //             }
  //             onChange={(e) => {
  //               const selectedValues =
  //                 questionData.questionType === "multipleChoice"
  //                   ? e.target.value
  //                   : [e.target.value];
  //               handleMatchingAnswerChange(selectedValues);
  //             }}
  //             renderValue={(selected) => {
  //               if (!Array.isArray(selected)) {
  //                 return (
  //                   questionData.choices.find(
  //                     (choice) => choice.value === selected
  //                   )?.label || ""
  //                 );
  //               }
  //               return selected
  //                 .map(
  //                   (value) =>
  //                     questionData.choices.find(
  //                       (choice) => choice.value === value
  //                     )?.label || ""
  //                 )
  //                 .join(",");
  //             }}
  //           >
  //             {questionData.choices.map((choice) => (
  //               <MenuItem key={choice.value} value={choice.value}>
  //                 {choice.label}
  //               </MenuItem>
  //             ))}
  //           </Select>
  //           <Typography variant="caption" color="textSecondary">
  //             {renderLabel()}
  //           </Typography>
  //         </FormControl>
  //       )}
  //     </Grid>
  //   );
  // }

  return <></>;
};

export default MatchingAnswer;
